export const SUPPORTED_LOCALES = [
  'en',
  'ar',
  'az',
  'be',
  'de',
  'es',
  'fa',
  'fr',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'nl',
  'pt',
  'ru',
  'th',
  'tr',
  'uk',
  'vi',
  'zh-Hans',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export const RTL_LOCALES: ReadonlySet<SupportedLocale> = new Set<SupportedLocale>(['ar', 'fa']);

export const ADMIN_LOCALES: readonly SupportedLocale[] = ['en', 'de', 'fr', 'es', 'tr', 'ja'] as const;

export interface LocaleMetadata {
  nativeName: string;
  englishName: string;
  dir: 'ltr' | 'rtl';
}

export const LOCALE_METADATA: Record<SupportedLocale, LocaleMetadata> = {
  en: { nativeName: 'English', englishName: 'English', dir: 'ltr' },
  ar: { nativeName: 'العربية', englishName: 'Arabic', dir: 'rtl' },
  az: { nativeName: 'Azərbaycanca', englishName: 'Azerbaijani', dir: 'ltr' },
  be: { nativeName: 'Беларуская', englishName: 'Belarusian', dir: 'ltr' },
  de: { nativeName: 'Deutsch', englishName: 'German', dir: 'ltr' },
  es: { nativeName: 'Español', englishName: 'Spanish', dir: 'ltr' },
  fa: { nativeName: 'فارسی', englishName: 'Persian', dir: 'rtl' },
  fr: { nativeName: 'Français', englishName: 'French', dir: 'ltr' },
  hi: { nativeName: 'हिन्दी', englishName: 'Hindi', dir: 'ltr' },
  id: { nativeName: 'Bahasa Indonesia', englishName: 'Indonesian', dir: 'ltr' },
  it: { nativeName: 'Italiano', englishName: 'Italian', dir: 'ltr' },
  ja: { nativeName: '日本語', englishName: 'Japanese', dir: 'ltr' },
  ko: { nativeName: '한국어', englishName: 'Korean', dir: 'ltr' },
  ms: { nativeName: 'Bahasa Melayu', englishName: 'Malay', dir: 'ltr' },
  nl: { nativeName: 'Nederlands', englishName: 'Dutch', dir: 'ltr' },
  pt: { nativeName: 'Português', englishName: 'Portuguese', dir: 'ltr' },
  ru: { nativeName: 'Русский', englishName: 'Russian', dir: 'ltr' },
  th: { nativeName: 'ไทย', englishName: 'Thai', dir: 'ltr' },
  tr: { nativeName: 'Türkçe', englishName: 'Turkish', dir: 'ltr' },
  uk: { nativeName: 'Українська', englishName: 'Ukrainian', dir: 'ltr' },
  vi: { nativeName: 'Tiếng Việt', englishName: 'Vietnamese', dir: 'ltr' },
  'zh-Hans': { nativeName: '中文', englishName: 'Chinese (Simplified)', dir: 'ltr' },
};

export function isRtl(locale: SupportedLocale): boolean {
  return RTL_LOCALES.has(locale);
}

export function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
